
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'
import { INewsData } from '@/api/types'
import { IEditorConfig } from '@wangeditor/editor'
import { UserModule } from '@/store/modules/user'
import { cloneDeep } from 'lodash'
import { Form } from 'element-ui'
import { dateFormat } from '@/utils/dateFormat'
import { insertNewsInfo, defaultNewsData, updateNewsInfo } from '@/api/news'
@Component({
  components: { Editor, Toolbar }
  })
export default class NewsPopper extends Vue {
  @Prop(String)
  dialogType: string | undefined;

  @Prop(Boolean)
  dialogVisible: boolean | undefined;

  @Prop()
  tempNewsData!: INewsData;

  private editor: any = Object;
  private html = '<p>hello</p>';
  private toolbarConfig = {};
  private mode = 'default'; // or 'simple'
  private imageUrl = '';
  private uploadImage = '';
  private imageData = { imageType: 'cover' };
  private imageHeaders = {
    'X-Access-Token': UserModule.token
  }

  private rules = {
    title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
    publishTime: [
      { required: true, message: '发布时间不能为空', trigger: 'blur' }
    ],
    content: [{ required: true, message: '正文不能为空', trigger: 'blur' }]
  };

  private editorConfig: Partial<IEditorConfig> = {
    MENU_CONF: {}
  };

  private onCreated(editor: any) {
    this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    console.log('onCreated', this.editor)
  }

  private resettempData() {
    this.tempNewsData = cloneDeep(defaultNewsData)
  }

  @Emit('save-data')
  private saveData(submitStatus: number) {
    this.tempNewsData.submitStatus = submitStatus
    this.tempNewsData.content = this.editor.getHtml?.()
    if (this.dialogType === 'create') {
      this.resettempData()
      if (submitStatus === 1) {
        this.$nextTick(() => {
          (this.$refs.dataForm as Form).validate(valid => {
            if (valid) {
              this.save()
            } else {
              this.$message({
                message: '必填项不能为空',
                type: 'warning'
              })
            }
          })
        })
      } else {
        this.save()
      }
    } else {
      if (submitStatus === 1) {
        (this.$refs.dataForm as Form).validate(valid => {
          if (valid) {
            this.upadate()
          } else {
            this.$message({
              message: '必填项不能为空',
              type: 'warning'
            })
          }
        })
      } else {
        this.upadate()
      }
    }
    return this.tempNewsData
  }

  @Emit('close-dialog')
  private closeDialog() {
    return ''
  }

  private async save() {
    this.tempNewsData.createTime = dateFormat(new Date())
    await insertNewsInfo(this.tempNewsData)
    this.closeDialog()
    this.$notify({
      title: '成功',
      message: '创建成功',
      type: 'success',
      duration: 2000
    })
  }

  private async upadate() {
    this.tempNewsData.updateTime = dateFormat(new Date())
    await updateNewsInfo(this.tempNewsData)
    this.closeDialog()
    this.$notify({
      title: '成功',
      message: '更新成功',
      type: 'success',
      duration: 2000
    })
  }

  private handleAvatarSuccess(res: any, file: any) {
    console.log(URL.createObjectURL(file.raw))
    console.log(res)
    this.imageUrl = URL.createObjectURL(file.raw)
    this.imageUrl = res.data.url
    this.tempNewsData.imgPath = res.data.url
  }

  private beforeAvatarUpload(file: any) {
    const isLt200K = file.size / 1024 / 100 < 2
    let isJPGOrPNG = true
    console.log(file)
    if (!/\.(jpg|jpeg|png|GIF|JPG|PNG)$/.test(file.name)) {
      this.$message.error('上传封面图片只能是 JPG或PNG格式!')
      isJPGOrPNG = false
    }
    if (!isLt200K) {
      this.$message.error('上传封面图片大小不能超过 200kB!')
    }
    return isJPGOrPNG && isLt200K
  }

  mounted() {
    this.uploadImage = process.env.VUE_APP_BASE_API + '/news/uploadImage'
    if (this.editorConfig.MENU_CONF !== undefined) {
      console.log('created')
      this.editorConfig.MENU_CONF.uploadImage = {
        server: this.uploadImage,
        fieldName: 'imageFile',
        maxFileSize: 1 * 1024 * 512, // 1M
        maxNumberOfFiles: 1,
        allowedFileTypes: ['image/*'],
        headers: {
          'X-Access-Token': UserModule.token
        },
        timeout: 5 * 1000, // 5 秒
        onSuccess(file: File, res: any) {
          // TS 语法
          // onSuccess(file, res) {          // JS 语法
          console.log(`${file.name} 上传成功`, res)
        },
        onFailed(file: File, res: any) {
          console.log(`${file.name} 上传失败`, res)
        },
        onError(file: File, err: any, res: any) {
          console.log(`${file.name} 上传出错`, err, res)
          alert(err)
        }
      }
    }
  }
}
